{
  "guest": {
    "passwordResetFields": {
      "oldPassword": "Old Password",
      "oldPasswordInvalid": "This field is required and should match your current password.",
      "newPasswordInvalid": "This field is required and must meet the requirements.",
      "confirmPassword": "Confirm Password",
      "confirmPasswordInvalid": "This field is required and should match the password above.",
      "passwordRequirements": "Password Requirements:",
      "minCharacters": "Minimum 8 characters.",
      "atLeastSymbol": "At least 1 symbol.",
      "atLeastNumber": "At least 1 number.",
      "passwordsMatch": "Passwords match."
    },
    "createAccount": {
      "additionalInformation": "Additional Information"
    },
    "emailForm": {
      "emailAlreadyRegistered": "This email is already registered in our system. Try recovering your password if this is your email.",
      "firstNameLabel": "First Name *",
      "fieldRequired": "This field is required.",
      "firstNamePlaceholder": "Enter your first name",
      "lastNameLabel": "Last Name *",
      "lastNamePlaceholder": "Enter your last name",
      "emailLabel": "Email *",
      "emailPlaceholder": "Enter your email",
      "emailAlreadyRegisteredInline": "This email is already registered in the system.",
      "fieldRequiredValidEmail": "This field is required and must be a valid email.",
      "phoneNumberLabel": "Phone Number",
      "passwordLabel": "Password"
    },
    "authLoginOneTime": {
      "loginProblem": "There was a problem with your login credentials.",
      "checkYourEmailHeading": "Check Your Email!",
      "emailSentTo": "We've sent an email to",
      "loginLinkInfo": "that contains a login link so you can sign-in with ease.",
      "resendPrompt": "Need a new email? Click here to re-send.",
      "loginHeading": "Login",
      "magicLinkInfo": "Get a magic link sent to your email that will log you in instantly.",
      "fieldRequired": "This field is required.",
      "sendLink": "Send Link"
    },
    "authLoginPassword": {
      "loginError": "There was a problem with your login credentials.",
      "emailLabel": "Email",
      "fieldRequired": "This field is required.",
      "passwordLabel": "Password",
      "forgotPassword": "Forgot password?",
      "signIn": "Sign in"
    },
    "authSocialButtons": {
      "continueWith": "Continue with {provider}"
    },
    "loginForm": {
      "welcomeBack": "Welcome back",
      "signInToAccount": "Sign in to your {tenantName} account.",
      "linkExpired": "The link you used has expired. Please log in to continue.",
      "or": "OR",
      "useEmailPassword": "Use email and password",
      "magicLink": "Email me a magic link",
      "noAccount": "Don't have an account?",
      "createOne": "Create one →"
    },
    "registerForm": {
      "completeProfileTitle": "Complete your profile",
      "createAccountTitle": "Create your account",
      "socialBasicsIntro": "We have your basics from",
      "socialBasicsOutro": ". Just a few more details to get you in.",
      "joinInSteps": "Join {name} in just a few steps.",
      "verifiedByProvider": "Verified by {provider} as",
      "orFillOutForm": "OR FILL OUT THE FORM",
      "alreadyHaveAccount": "Already have an account?",
      "signIn": "Sign in →"
    },
    "resetEmail": {
      "title": "Reset Password",
      "expiredNotice": "The link you used has expired. Please reset your password to continue.",
      "emailLabel": "Email *",
      "emailRequired": "The email field is required.",
      "emailPlaceholder": "Enter the email associated with your account",
      "submitButton": "Send Password Reset Link"
    },
    "resetForm": {
      "heading": "Reset Password",
      "emailLabel": "Email *",
      "emailRequired": "The email field is required.",
      "emailPlaceholder": "Enter the email associated with your account",
      "resetButton": "Reset Password",
      "tokenExpired": "The reset token has expired. Please",
      "goBackLink": "go back and try again",
      "tokenExpiredHelp": "if you still need to reset your password."
    }
  },
  "manager": {
    "accountEmailField": {
      "emailLabel": "Email *",
      "emailInvalid": "Must be an email.",
      "emailPlaceholder": "Enter an email"
    },
    "accountInfo": {
      "personalInformation": "Personal Information",
      "memberId": "Member ID",
      "fullName": "Full Name",
      "email": "Email",
      "phoneNumber": "Phone Number",
      "businessName": "Business Name",
      "addressInformation": "Address Information",
      "address": "Address",
      "addressTwo": "Address 2",
      "city": "City",
      "postal": "Postal",
      "province": "Province",
      "country": "Country",
      "additionalInformation": "Additional Information",
      "manager": "Manager",
      "password": "Password",
      "changePassword": "Change Password",
      "triggerPasswordReset": "Trigger Password Reset",
      "profileFields": "Profile Fields",
      "noProfileFields": "No custom profile fields have been created.",
      "notAvailable": "N/A"
    }
  },
  "user": {
    "addressForm": {
      "streetAddressLabel": "Street Address *",
      "streetAddressPlaceholder": "Enter your street address",
      "streetAddressTwoLabel": "Street Address 2",
      "streetAddressTwoPlaceholder": "Suite or Apartment #",
      "cityLabel": "City *",
      "cityPlaceholder": "Enter your city",
      "postalLabel": "Postal/Zip Code",
      "postalPlaceholder": "A1A 1A1",
      "regionLabel": "Region",
      "countryLabel": "Country *"
    },
    "identityWelcomeMasthead": {
      "logoAlt": "Communal",
      "ctaCopy": "New to Communal? See it before you sign up. We'll walk you through a real workflow, no canned tour and no sales script.",
      "bookDemo": "Book a demo"
    },
    "directoryEntryPage": {
      "title": "Find your organization",
      "lede": "Enter the email you use on Communal. We'll send a 6-digit code to confirm it's you, then take you to the right place.",
      "emailLabel": "Email",
      "emailPlaceholder": "you{'@'}example.com",
      "sendingCode": "Sending code…",
      "emailMeCode": "Email me a sign-in code",
      "or": "or"
    },
    "directoryResultsPage": {
      "kicker": "Verified",
      "headline": "Pick a place to land.",
      "subtitle": "Choose where you want to land. We'll hand you off to that organization's sign-in.",
      "title": "You're in. Pick an organization.",
      "ledeIntro": "These are the Communal organizations linked to",
      "ledeOutro": ". Forgot a password? Use the \"Forgot password\" link after you click through.",
      "emptyMessage": "We couldn't find any active organizations for this email. Reach out to your admin if you think this is wrong.",
      "paginationShowing": "Showing",
      "paginationOf": "of",
      "paginationOrganizations": "organizations",
      "paginationPagesLabel": "Organization pages",
      "lookUpAnotherEmail": "Look up another email"
    },
    "directoryVerifyPage": {
      "kicker": "Verify",
      "headline": "Confirm it's you.",
      "subtitle": "Almost there. Enter the 6-digit code we just emailed you to confirm it's really you.",
      "checkYourEmail": "Check your email",
      "codeSentTo": "We sent a 6-digit code to",
      "codeExpires": ". It expires in 15 minutes.",
      "codeLabel": "6-digit code",
      "verifying": "Verifying…",
      "continue": "Continue",
      "didntGetIt": "Didn't get it?",
      "sendAnotherCode": "Send another code"
    },
    "resetPassword": {
      "welcome": "Welcome, {name}!",
      "setPasswordInstruction": "Please set your password using the form below.",
      "newPassword": "New Password",
      "newPasswordInvalidFeedback": "This field is required and must meet the requirements.",
      "confirmPassword": "Confirm Password",
      "confirmPasswordInvalidFeedback": "This field is required and should match the password above.",
      "passwordRequirements": "Password Requirements:",
      "minCharacters": "Minimum 8 characters.",
      "atLeastOneSymbol": "At least 1 symbol.",
      "atLeastOneNumber": "At least 1 number.",
      "passwordsMatch": "Passwords match."
    }
  }
}
